/**
 * Created by pzf on 2018/10/31
 *
 */
import React, { useState, useMemo, useEffect, useRef, useCallback, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';
import { Form } from 'mkui-fd';
import { getProps } from './util';
import { COMPONENT_TYPE, FIELD_MAPPING } from './constant';
var FormItem = Form.Item;
export default function FieldItem(props) {
  var field = props.field,
      form = props.form;
  var getFieldDecorator = form.getFieldDecorator;
  var getComponent = useCallback(function () {
    var componentType = COMPONENT_TYPE[field.type];
    warning(componentType, 'type of field excepted input|select|date-picker|time-picker|currency-input|other custom components');
    var componentClass = FIELD_MAPPING[componentType];
    warning(componentClass, "component of ".concat(componentType, " is undefinded"));
    return componentClass;
  }, [field]);
  var buildRule = useCallback(function () {
    return field.property.rules;
  }, [field]);
  var Field = getComponent();
  return React.createElement(FormItem, {
    label: field.property.name
  }, getFieldDecorator(field.identifier, {
    rules: buildRule()
  })(React.createElement(Field, getProps(field))));
}
FieldItem.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object
};
FieldItem.defaultProps = {
  field: {}
};
//# sourceMappingURL=FieldItem.js.map
